import React, { useState } from "react";
import { Form } from "react-bootstrap";
import ModalWrapper from "common/ui/Modal";
import FormValidation, { useFormValidation } from "common/ui/FormValidation";
import ErrorList from "common/ui/ErrorList";

interface ManualErpIdModalProps {
  erpId: string;
  onClose: () => void;
  onSubmit: (erpId: string) => void;
  errors: string[];
  cancelButtonText: string;
};

const ManualErpIdModal: React.FC<ManualErpIdModalProps> = (props: ManualErpIdModalProps) => {
  const [erpId, setErpId] = useState(props.erpId || '');
  const formValidator = useFormValidation();

  function handleOnClose() {
    props.onClose();
  }

  function handleSubmit() {
    if (formValidator.current.validate()) {
      props.onSubmit(erpId);
    }
  }

  return <ModalWrapper
    title="Enter ERP ID"
    onAdvance={handleSubmit}
    onCancel={handleOnClose}
    advanceButtonText="Submit"
    cancelButtonText={props.cancelButtonText}>
    <FormValidation ref={formValidator}>
      <Form.Group>
        <Form.Label>ERP ID#</Form.Label>
        <Form.Control
          type="text"
          value={erpId}
          onChange={(e) => setErpId(e.target.value)}
          maxLength={16}
          placeholder="Enter ERP ID#"
          autoFocus
          required
        />
        <Form.Control.Feedback type="invalid">
          ERP ID# is required
        </Form.Control.Feedback>
      </Form.Group>
    </FormValidation>

    <ErrorList errors={props.errors} />
  </ModalWrapper>;
}

export default ManualErpIdModal;